var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 20",
    style: {
      enableBackground: "new 0 0 16 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#323338;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7625",
    className: "st0",
    d: "M16,17.6V6.8c0-0.5-0.2-1-0.6-1.4l-4.8-4.8C10.2,0.2,9.7,0,9.2,0H2C0.9,0,0,0.9,0,2l0,16 c0,1.1,0.9,2,2,2h12c0.4,0,0.8-0.1,1.2-0.4l-4.4-4.4c-0.9,0.6-1.9,0.9-3,0.8C5,15.8,2.9,13.5,3,10.7S5.5,5.9,8.3,6 c0.2,0,0.4,0,0.6,0.1c2.7,0.5,4.5,3.1,4.1,5.8c-0.1,0.7-0.4,1.3-0.8,1.9L16,17.6z M5,11c0,1.7,1.3,3,3,3s3-1.3,3-3S9.7,8,8,8 S5,9.3,5,11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/activity_icon.3c4ee93d520b13a91f23fedc81cacf21.svg";
export { ForwardRef as ReactComponent };